{
  "action": {
    "confirm": "Confirm",
    "delete": "Delete",
    "discard": "Discard",
    "keep": "Keep",
    "restore": "Restore",
    "retire": "Retire"
  },
  "empty": "No memories here.",
  "inThread": {
    "keptHere": "The memory this Run keeps",
    "title_one": "{{count}} memory kept from this Run",
    "title_other": "{{count}} memories kept from this Run"
  },
  "keep": {
    "explanation": "The memory links to these Run passages so agents can read their exact wording.",
    "fromEntry": "Run entry #{{number}}",
    "note": "Note (optional)",
    "noteHelp": "In your own words, if the passage alone does not say why it matters.",
    "skipped_one": "{{count}} selected part cannot be quoted and is left out: it is not text of a message, answer or comment.",
    "skipped_other": "{{count}} selected parts cannot be quoted and are left out: they are not text of a message, answer or comment.",
    "title": "Title"
  },
  "keepAction": "Keep as memory",
  "lastUsed": "used {{at}}",
  "mine": {
    "explanation": "Memories only you and your agents can read. Choose a project to see its personal memories.",
    "explanationInProject": "Your personal memories for {{project}}. Only you and your agents can read them.",
    "title": "My memories"
  },
  "neverUsed": "never used",
  "openThread": "Open its Run",
  "origin": {"agent": "saved by an agent", "person": "kept by a person"},
  "reason": "Why: {{reason}}",
  "saved": {
    "kept": "The agent kept a memory: {{title}}.",
    "keptPersonal": "The agent kept a personal memory.",
    "proposed": "The agent proposed a memory: {{title}}. It waits for a person to confirm it.",
    "proposedPersonal": "The agent proposed a personal memory. It waits for you to confirm it.",
    "review": "Review it in its Run"
  },
  "state": {"active": "Active", "proposed": "Waiting", "retired": "Retired", "stale": "Unused"},
  "stateFilter": "Memory state",
  "step": {
    "noMemory": "This review step names no memory.",
    "noPassages": "This keep step names no passages to keep.",
    "waitsForOwner": "Only the person this memory belongs to can confirm or discard it."
  },
  "title": "Memories",
  "uses_one": "{{count}} use",
  "uses_other": "{{count}} uses",
  "wording": {
    "discardDraft": "Discard draft",
    "edit": "Edit",
    "notSaved": "Your draft was not saved: its review step took over the wording.",
    "save": "Save the wording"
  }
}
